<template>
  <v-dialog v-model="dialog" max-width="586px" @keydown.esc="cancel" persistent>
    <v-form ref="form" class="pa-6 text-start">
      <div class="text-caption">
        Edit pool name
        <v-text-field
          :disabled="loading"
          placeholder="Enter title for claim list"
          outlined
          dense
          v-model="name"
          class="mt-1 rounded-xl text-body-2"
          :rules="[$rules.required]"
        >
        </v-text-field>
      </div>
      <div class="d-flex justify-space-between">
        <v-btn outlined rounded min-width="100px" @click="dialog = false">Cancel</v-btn>
        <v-btn class="primary" rounded min-width="100px" @click="save" :loading="loading">Save</v-btn>
      </div>
    </v-form>
  </v-dialog>
</template>
      
<script>
import { mapState } from 'vuex'
export default {
  props: {
    state: Boolean,
    claim: Object,
  },
  components: {},
  computed: {
    ...mapState('auth', ['multiClaimHandler']),
  },
  methods: {
    async save() {
      try {
        this.loading = true
        if (!this.$refs.form.validate()) return
        const res = await this.multiClaimHandler.changeName(this.claim.id, this.name)
        if (res) {
          this.$emit('updateDone', this.name)
          this.$alert.success('Update pool name successed')
        } else {
          this.$alert.error('Update pool name failed')
        }
        this.dialog = false
      } catch (e) {
        this.$alert.error(e.message)
      } finally {
        this.loading = false
      }
    },
    async resetDefault() {
      if (this.$refs.form && !this.loading) {
        await this.$refs.form.reset()
      }
      if (!this.loading) this.name = this.claim.name
    },
  },
  created() {
    this.resetDefault()
  },
  data() {
    return {
      name: '',
      dialog: false,
      loading: false,
    }
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    state(state) {
      this.dialog = true
      this.resetDefault()
    },
  },
}
</script>